<ng-container *ngIf="date">
    <div class="day-card">
        <span>
            {{month}}
        </span>
        <strong>
            {{day}}
        </strong>
    </div>
</ng-container>